import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	padding: 3em 0 2em 0;

	.slick-container {
		transform: translateX(-0.5em);
		width: calc(100% + 0.5em);
		.layout-slick .slick-slider .slick-arrow {
			&.slick-prev {
				left: -5%;
			}
			&.slick-next {
				right: -5%;
			}
		}
		&.hide-arrows {
			.layout-slick-button {
						display: none;
					}
		}
	}
	.gallery-container {
		width: 16em;
		height: 16em;

		.gallery-image {
			object-fit: cover;
			object-position: center;
			width: 16em;
			height: 16em;
			margin: 0 auto;
		}
	}

	.gallery-container-single {
		width: 100%;
		max-height: 20em;
		overflow: hidden;

		.gallery-image {
			object-fit: scale-down;
			max-height: 20em;
			margin: 0 auto;
		}
	}
	.preview {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 99;
		background-color: rgba(0,0,0,.5);
		.layout-slick {
			height: 100%;
			.slick-slider {
				.slick-arrow {
					&.slick-prev {
						left: 10%;
					}
					&.slick-next {
						right:10%;
					}
				}
			}
		}
		.preview__close {
			appearance: none;
			background: none;
			border: none;
			position: absolute;
			right: 10%;
			top: 6em;
			z-index: 10;
			cursor: pointer;
		}
		.preview__close-img {
			width: 2em;
			height: 2em;
		}
		.slick-slider {
			height: 100%;
		}
		.slick-list {
			height: 100%;
		}
		.slick-track {
			height: 100%;
		}
		.slick-slide {
			div {
				height: 100%;
				display: flex !important;
				justify-content: center;
				align-items: center;
			}

		}
	}
	.preview__image {
		margin: 0 auto;
		width: 90%;
		height: 70%;
		object-fit: contain;
	}
	@media(max-width: ${vars.desktopXS}) {
		.preview {
			.preview__close {
				right:5%;
			}
		}
	}
`;
